import { render } from "./ContactGrid.vue?vue&type=template&id=1069100c"
import script from "./ContactGrid.vue?vue&type=script&lang=js"
export * from "./ContactGrid.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__